import axios from 'axios'

export default {
    async getTrusted() {
        try{            
            const response = await axios.get(`UserDevices/trusted`)                                                           
            return response
        }catch (error){
            console.log('UserDevices getTrusted error')
            throw error
        }
    },
    async removeDevice(data) {
        try{            
            const response = await axios.post(`UserDevices/remove`, data)            
            return response
        }catch (error){
            console.log(' WebAuthn removeDevice error')
            throw error
        }
    },
}